import React from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../head-container';

const AttemptsExhaustedComponent = ({
  setScreenNumber,
  handleCheckNumberClick
}) => (
  <div className={styles.container}>
    <div className={styles.inner}>
      <HeadContainer setScreenNumber={setScreenNumber} />
      <div className={styles.content}>
        <p className={styles.title}>Спроби вичерпані:(</p>
        <p className={styles.banner}>
          Спробуй перевірити вказаний номер телефону та зареєструватися знову!
        </p>
        <div className={styles.buttonContainer}>
          <button
            className={styles.blueButton}
            onClick={handleCheckNumberClick}
          >
            <span>Перевірити номер</span>
          </button>
          <button
            className={styles.whiteButton}
            onClick={() => setScreenNumber(1)}
          >
            Перейти в меню
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AttemptsExhaustedComponent;
